var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/CommonStory/CommonStoryImage.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/CommonStory/CommonStoryImage.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"CommonStoryBlock CommonStoryImage\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\">\n\n        <figure class=\"CommonStoryImage-image CommonStoryImage-image--";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"alignment") || "horizontal", env.opts.autoescape);
t_5 += " CommonStoryImage-image--";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"wide")) {
t_5 += "wide";
;
}
else {
t_5 += "normal";
;
}
t_5 += "\">\n            <div class=\"CommonStoryImage-imageWrapper\">\n                <div class=\"CommonStoryImage-imagePlaceholder\" style=\"padding-top: ";
t_5 += runtime.suppressValue(100 / runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"aspect"), env.opts.autoescape);
t_5 += "%\">\n                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"wide")) {
t_5 += "\n                        <img src=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"images")),0)),"img")),"w1366_url"), env.opts.autoescape);
t_5 += "\"\n                          srcset=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"images")),0)),"img")),"w1920_url"), env.opts.autoescape);
t_5 += " 1920w,\n                                  ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"images")),0)),"img")),"w1680_url"), env.opts.autoescape);
t_5 += " 1680w,\n                                  ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"images")),0)),"img")),"w1366_url"), env.opts.autoescape);
t_5 += " 1366w,\n                                  ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"images")),0)),"img")),"w920_url"), env.opts.autoescape);
t_5 += " 920w,\n                                  ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"images")),0)),"img")),"w680_url"), env.opts.autoescape);
t_5 += " 680w\"\n                          sizes=\"(max-width: 759px) 1, ";
t_5 += "\n                                 (min-width: 760px) and (max-width: 979px) 681, ";
t_5 += "\n                                 calc(100% - 240px)\" ";
t_5 += "\n                          alt=\"\">\n                    ";
;
}
else {
t_5 += "\n                        <img src=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"images")),0)),"img")),"w680_url"), env.opts.autoescape);
t_5 += "\"\n                          srcset=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"images")),0)),"img")),"w1366_url"), env.opts.autoescape);
t_5 += " 1366w,\n                                  ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"images")),0)),"img")),"w680_url"), env.opts.autoescape);
t_5 += " 680w\"\n                          sizes=\"(max-width: 759px) 1, ";
t_5 += "\n                                 100vw\"\n                          alt=\"\">\n                    ";
;
}
t_5 += "\n                </div>\n            </div>\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"images")),0)),"textRendered")) {
t_5 += "\n                <div class=\"CommonStoryImage-imageCaptionWrapper\">\n                    <figcaption class=\"CommonStoryImage-imageCaption\">";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"images")),0)),"textRendered")), env.opts.autoescape);
t_5 += "</figcaption>\n                </div>\n            ";
;
}
t_5 += "\n        </figure>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("CommonStoryImage");
context.setVariable("CommonStoryImage", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/CommonStory/CommonStoryImage.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonStory/CommonStoryImage.jinja
// module id = 92
// module chunks = 0